<script setup>
import dayjs from 'dayjs';

defineProps({
  date: String,
  location: String,
  subLocation: String,
  cost: String,
  time: String,
});

const lineByLineDate = (date) => {
  const d = dayjs(date);
  return `${d.format('ddd')} ${d.format('MMM')} ${d.date()}, ${d.year()}`;
};

</script>

<template>
  <div class="font-FordAntennaMed text-lg leading-normal">
    <div v-if="date" class="mb-7 [&>div]:mb-4">
      <div class="font-FordAntennaReg text-ford-blue-electric text-sm">
        DATE
      </div>
      <div>
        {{ lineByLineDate(date.start) }}
      </div>
      <div v-if="lineByLineDate(date.start) !== lineByLineDate(date.end)">
        {{ lineByLineDate(date.end) }}
      </div>
    </div>

    <div v-if="location || subLocation" class="mb-7 [&>div]:mb-4">
      <div class="font-FordAntennaReg text-ford-blue-electric text-sm">
        LOCATION
      </div>
      <div>{{ location }}</div>
      <div class="font-FordAntennaReg -mt-2.5">
        {{ subLocation }}
      </div>
    </div>

    <div v-if="time" class="mb-7 [&>div]:mb-4">
      <div class="font-FordAntennaReg text-ford-blue-electric text-sm">
        TIME
      </div>
      <div>{{ time }}</div>
    </div>

    <div v-if="cost" class="mb-7 [&>div]:mb-4">
      <div class="font-FordAntennaReg text-ford-blue-electric text-sm">
        COST
      </div>
      <div>{{ cost }}</div>
    </div>
  </div>
</template>
